export default "__VITE_ASSET__DBwLyEig__"